interface BaseCommand {
  version: string;
  command: string;
}

interface BroadcastCommand extends BaseCommand {
  type: string;
  data?: any;
}

interface DoSendMessageToApp extends BaseCommand {
  appId: string;
  type: string;
  data?: any;
}

interface GotoAppCommand extends BaseCommand {
  appId: string;
  url: string;
  isCompliant: boolean;
}

interface LogoffCommand extends BaseCommand {}

interface RemoveSplashCommand extends BaseCommand {}

interface SendMessageToAppCommand extends BaseCommand {
  appId: string;
  type: string;
  data?: any;
}

interface SetDirtyMessageEnabledCommand extends BaseCommand {
  allowDirtyMessage: boolean;
}

interface SetLogoffUrlCommand extends BaseCommand {
  logoffUrl: string;
}

interface TimeoutCommand extends BaseCommand {
  url: string;
}

interface UpdateAppNameCommand extends BaseCommand {
  appId: string;
  appName: string;
}

interface UpdateDirtyFlagCommand extends BaseCommand {
  appId: string;
  dirtyFlag: boolean;
}

export type PostMessageCommand =
  | BroadcastCommand
  | DoSendMessageToApp
  | GotoAppCommand
  | LogoffCommand
  | RemoveSplashCommand
  | SendMessageToAppCommand
  | SetDirtyMessageEnabledCommand
  | SetLogoffUrlCommand
  | TimeoutCommand
  | UpdateDirtyFlagCommand
  | UpdateAppNameCommand;

export const BROADCAST = 'broadcastMessage';
export const DO_SEND_MESSAGE_TO_APP = '_sendMessageToApp';
export const GOTO_APP = 'gotoApp';
export const LOGOFF = 'logoff';
export const REMOVE_SPLASH = 'removeSplash';
export const SEND_MESSAGE_TO_APP = 'sendMessageToApp';
export const SET_DIRTY_MESSAGE_ENABLED = 'setDirtyMessageEnabled';
export const SET_LOGOFF_URL = 'setLogoffUrl';
export const TIMEOUT = 'timeout';
export const UPDATE_APP_NAME = 'updateAppName';
export const UPDATE_DIRTY_STATE = 'updateDirtyFlag';

// is version still necessary?
export const VERSION = '5.0';
export const ORIGIN = '*';
